// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { CompleteAttribute } from './CompleteAttribute';
import { BEDTO } from './BEDTO';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 数据传输对象属性 实体类
 * 数据传输对象属性
 */
export class DTOAttribute extends CompleteAttribute {
  /** 是否在构造器中 : 是否在构造器中，false则需要实例化以后另行设置 */
  private _isInConstructor: boolean;

  /** 设置：是否在构造器中 */
  public get isInConstructor() {
    return this._isInConstructor;
  }

  /** 获取：是否在构造器中 */
  public set isInConstructor(value: boolean) {
    this._isInConstructor = value;
  }

  /** 所属的数据传输对象 的ID */
  private _dTO_ID: string;

  /** 获取：所属的数据传输对象 的ID */
  public get dTO_ID() {
    return this._dTO_ID;
  }

  /** 设置：所属的数据传输对象 的ID */
  public set dTO_ID(value: string) {
    this._dTO_ID = value;
  }

  /** 所属的数据传输对象  */
  private _dTO: BEDTO;

  /** 获取：所属的数据传输对象  */
  public get dTO() {
    return this._dTO;
  }

  /** 设置：所属的数据传输对象  */
  public set dTO(value: BEDTO) {
    this._dTO = value;
    if (value !== null) {
      this.dTO_ID = value.id;
    } else {
      this.dTO_ID = '';
    }
  }

  constructor() {
    super();
    this._isInConstructor = false;
    this._dTO_ID = '';
    this._dTO = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DTOAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isInConstructor = element.isInConstructor;
      this.dTO_ID = element.dTO_ID;
      if (hasReference && element.dTO !== null) {
        this.dTO = element.dTO;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isInConstructor = json.IsInConstructor;
    this.dTO_ID = json.DTO_ID;
    // if (json.DTO !== null) {
    //   this.dTO = BEDTO.Create(json.DTO);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsInConstructor = this.isInConstructor;
    json.DTO_ID = this.dTO_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'isInConstructor', '是否在构造器中', EnumDataType.Bool, this.isInConstructor, true, '是否在构造器中，false则需要实例化以后另行设置', '', '');
    return context;
  }

  static Create(json: any): DTOAttribute {
    const dTOAttribute = new DTOAttribute();
    dTOAttribute.Deserialize(json);
    dTOAttribute.json = json;
    return dTOAttribute;
  }
}
